import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class CashBackCampCodeFilter extends Component {
    state = {
        campaignCodeLists:[],
        campaignCodeValue: '',
        isCampLoading: true
    };
    componentDidMount(){
        this.get_campaign_code(this.props.start_date,this.props.end_date);
    }
    resetCmpaignCode()
    {
        this.setState({
            campaignCodeValue: [],
        })
    }
    get_campaign_code(start_date, end_date){
        this.setState({
            campaignCodeLists:[],
            campaignCodeValue: [],
            isCampLoading: true
        })
        axios.post(config.get('API_URL')+'/reports/cashback-campcode/',{
                yestSend: start_date,
                todSend: end_date,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                this.setState({
                    campaignCodeLists:[]
                })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((camp_code, index) => {
                    this.state.campaignCodeLists.push({value: camp_code.camp_code, label: camp_code.camp_code})
                });
            }
            this.setState({
                isCampLoading: false
            })
        });

    }


    changeCampaignCode(optionSelected){
        let value='';
        let campCodeArray = [];
        if(optionSelected.length < 1){
            value = null;
            campCodeArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                campCodeArray.push(mids.value)
                var index = this.state.campaignCodeLists.findIndex(obj => obj.value==mids.value);
                this.state.campaignCodeLists.move(index,0).join(',');
            });
        }
        this.props.OnSelectCampaignCode(optionSelected, campCodeArray);
        this.setState({
            campaignCodeValue:optionSelected,
        });
    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="campaign"
                isMulti
                value={this.state.campaignCodeValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeCampaignCode.bind(this)}
                options={this.state.campaignCodeLists}
                placeholderButtonLabel="Select [Campaign]"
                isLoading={this.state.isCampLoading}
            />
        );

    }
}
export default CashBackCampCodeFilter;